import React from 'react';
import { motion } from 'framer-motion';
import about_us_believe_image from '../../Assets/images/about_us_believe_image.png';
import about_us_learningApproach_img from '../../Assets/images/about_us_learningApproach_img.png';

const motionVariants = [
    {
        hidden: { opacity: 0, y: -40 },
        visible: { opacity: 1, y: 0 },
    },
    {
        hidden: { opacity: 0, x: -100 },
        visible: { opacity: 1, x: 0 },
    },
    {
        hidden: { opacity: 0, x: 100 },
        visible: { opacity: 1, x: 0 },
    },
    {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0 },
    },
];

const motionProperties = {
    initial: "hidden",
    whileInView: "visible",
    transition: { duration: 1, delay: 0.5 }
};

const WhatWeBelieve = () => {
    return (
        <div className='py-10'>
            <div className='lg:grid lg:grid-cols-2 flex flex-col-reverse gap-8'>
                <motion.div
                    {...motionProperties}
                    variants={motionVariants[0]}
                >
                    <img src={about_us_believe_image} alt="believe_img" className='w-full' />
                </motion.div>
                <motion.div
                    {...motionProperties}
                    variants={motionVariants[1]}
                    className='flex items-center'
                >
                    <div>
                        <h1 className='font-bold text-2xl text-slate-200 mb-2'>What we believe in ?</h1>
                        <p className='text-slate-300 text-xl text-justify'>Learning isn’t a privilege but the cause of individual progress. With the potential to transform the world to prosperity and even our lives, learning must never stop no matter where we are! That’s why to help you get access to quality learning, Techmentee, the best training and placement agency in Atlanta, GA, USA, is here with the best-in-class industry experts.</p>
                        <p className='text-slate-300 text-xl text-justify'>Our foundation is based on the promise that our learners’ best interests are of utmost significance.</p>
                    </div>
                </motion.div>
            </div>
            <div className='grid lg:grid-cols-2 grid-cols-1 gap-8 mt-10'>
                <motion.div
                    {...motionProperties}
                    variants={motionVariants[2]}
                    className='flex items-center'
                >
                    <div>
                        <h1 className='font-bold text-2xl mb-2 text-slate-200'>Our approach to digital learning!</h1>
                        <p className='text-slate-300 text-xl text-justify'>
                            With the vision to train the world's workforce with future careers, Techmentee was established as an IT training and placement consultancy in Atlanta, GA, USA, where lifelong learners can come to upskill themselves and land a great leap in their professions. However, building such a flexible training platform needed a unique approach. That's why Techmentee has adopted Re-know and Re-gather as its approach to creating interactive programs so that even the busiest learners can upskill themselves with the most in-demand industry-specific skills!
                        </p>
                    </div>
                </motion.div>
                <motion.div
                    {...motionProperties}
                    variants={motionVariants[3]}
                >
                    <img src={about_us_learningApproach_img} alt="believe_img" className='w-full' />
                </motion.div>
            </div>
        </div>
    );
}

export default WhatWeBelieve;
